import { useApi, createApiHook } from "../utils/apiUtils";

const useExpireInAppTime = () => {
  const { apiPatch } = useApi();
  const useApiState = createApiHook(null);
  const { data, error, loading, startLoading, setResponse } = useApiState();

  const expireInAppTime = async (assignappId) => {
    startLoading();
    const response = await apiPatch(`/assignapps/${assignappId}/expire_in_app_time`, "Error al expirar el tiempo de la aplicación", {});
    setResponse(response);
    return response.data;
  };

  return { expireInAppTime, data, error, loading };
};

export default useExpireInAppTime;
